import Lenis from '@studio-freight/lenis'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

let lenis

export function initSmoothScroll() {
  if (lenis) return lenis // ⛔ da se ne init više puta

  lenis = new Lenis({
    duration: 1.1,
    smooth: true,
    smoothWheel: true,
    smoothTouch: false,
    easing: (t) => 1 - Math.pow(1 - t, 3),
  })

  // 🔗 Sync Lenis ↔ GSAP
  lenis.on('scroll', ScrollTrigger.update)

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000)
  })

  gsap.ticker.lagSmoothing(0)

  return lenis
}

export function scrollToTop() {
  if (lenis) {
    lenis.scrollTo(0, { immediate: true });
    return;
  }

  // Fallback when Lenis is not initialized (e.g. before any page calls initSmoothScroll).
  if (typeof window !== 'undefined') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
